import styled from '@emotion/styled'
import { Card, Typography } from '@mui/material'
import { Box } from '@mui/system'
import HorizontalText from 'components/container/HorizontalText'
import { ONE, PERCENT, ZERO } from 'constants/number'
import { observer } from 'mobx-react-lite'
import { useMemo } from 'react'
import { poolService } from 'services/poolService'
import { poolStore } from 'stores'
import { toA } from 'utils/display'

const CustomBox = styled(Box)`
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  gap: 0px 100px;
`

const CustomColumn = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex-basis: 100%;
  flex: 1;
  min-width: min-content;
  padding: 4px 0px;
`

const PoolInfoCard = observer(() => {
  const poolAddr = poolService.poolAddress
  const { totalSuppliedUSD, totalBorrowedUSD, poolConfig } =
    poolStore.getPool(poolAddr)
  const adminFee = poolConfig && parseFloat(poolConfig.fee_rate) * 100
  const utilization = useMemo(() => {
    const supply = totalSuppliedUSD?.gt(ZERO) ? totalSuppliedUSD : ONE // Magic number
    const borrow = totalBorrowedUSD || ZERO
    return borrow.div(supply).times(PERCENT)
  }, [totalBorrowedUSD, totalSuppliedUSD])

  return (
    <Card sx={{ border: 'none', paddingBottom: '20px' }}>
      <Typography variant="h6" mb="24px">
        Pool info
      </Typography>
      <CustomBox>
        <CustomColumn>
          <HorizontalText
            left="Total supplied"
            right={toA(totalSuppliedUSD)}
            prefix="$"
            rb
          />
          <HorizontalText
            left="Total borrowed"
            right={toA(totalBorrowedUSD)}
            prefix="$"
            rb
          />
          <HorizontalText
            left="Pool utilization"
            right={toA(utilization)}
            suffix="%"
            rb
          />
        </CustomColumn>
        <CustomColumn>
          <HorizontalText
            left="Pool management fee"
            right={toA(adminFee)}
            suffix="%"
            rb
          />
          <HorizontalText left="Whitelisted" right="Yes" rb />
        </CustomColumn>
      </CustomBox>
    </Card>
  )
})

export default PoolInfoCard
